var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledTutorSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 12c1.324 0 2.4-1.076 2.4-2.4 0-1.324-1.076-2.4-2.4-2.4a2.402 2.402 0 0 0-2.4 2.4c0 1.324 1.076 2.4 2.4 2.4m3.6 6a.6.6 0 0 0 .6-.6c0-2.316-1.885-4.2-4.2-4.2a4.205 4.205 0 0 0-4.2 4.2.6.6 0 0 0 .6.6h7.2z",
    id: "2w0v3zkmva"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.933c2.364 0 4.286-1.913 4.286-4.266 0-2.353-1.922-4.267-4.286-4.267S5.214 4.314 5.214 6.667c0 2.353 1.922 4.266 4.286 4.266M15.929 21.6c.592 0 1.071-.478 1.071-1.067 0-4.117-3.365-7.466-7.5-7.466S2 16.416 2 20.533c0 .59.479 1.067 1.071 1.067H15.93z",
    id: "9v3sveupdb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F60",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2w0v3zkmva"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9v3sveupdb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledTutorSession);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-tutor-session.f801b83bd831eeab4f2491c53c204043.svg";
export { ForwardRef as ReactComponent };